import { Rows2, Rows4 } from "lucide-react";
import { useTranslation } from "react-i18next";
import { type Density, useUiStore } from "../stores/ui-store.ts";

/**
 * «كثافة العرض» — segmented comfortable/compact switch. Device-local
 * preference (ui-store → localStorage), so each workstation keeps its own
 * density. Rendered in the clinic settings "features" section and in the
 * mobile nav drawer footer next to theme/language.
 */
export function DensityToggle() {
	const { t } = useTranslation("common");
	const density = useUiStore((s) => s.density);
	const setDensity = useUiStore((s) => s.setDensity);

	const options: Array<{
		value: Density;
		icon: typeof Rows2;
		label: string;
	}> = [
		{ value: "comfortable", icon: Rows2, label: t("density.comfortable") },
		{ value: "compact", icon: Rows4, label: t("density.compact") },
	];

	return (
		<div
			aria-label={t("density.label")}
			className="inline-flex rounded-lg border border-border p-0.5 bg-muted/60"
		>
			{options.map(({ value, icon: Icon, label }) => {
				const active = density === value;
				return (
					<button
						key={value}
						type="button"
						aria-pressed={active}
						onClick={() => setDensity(value)}
						className={`inline-flex items-center gap-1.5 rounded-md px-3 min-h-10 sm:min-h-8 text-sm sm:text-xs font-medium transition-colors duration-150 ${
							active
								? "bg-card text-brand-700 dark:text-brand-300 shadow-sm"
								: "text-muted-foreground hover:text-foreground"
						}`}
					>
						<Icon className="size-4 shrink-0" strokeWidth={2} aria-hidden />
						{label}
					</button>
				);
			})}
		</div>
	);
}
